import auth from "../services/authService";
import { ActionTypes } from "../constants";
import { logoutOn401 } from "./commonActions";

export const getUserInfo = () => (dispatch, getState) => {
    auth.getUserInfo().then(
        response => {
            dispatch({ type: ActionTypes.GET_USER_INFO, data: response });
        }
    ).catch(logoutOn401(dispatch));

};

export const getApplications = () => (dispatch, getState) => {
    auth.getApplications().then(
        response => {
            dispatch({ type: ActionTypes.GET_APPLICATIONS, data: response });
        }
    ).catch(logoutOn401(dispatch));
};

export const activateApplication = (appCode, uuid) => (dispatch) => {
    dispatch({type: ActionTypes.ACTIVATE_APPLICATION, payload: { appCode, uuid }})
};

export const getMfaMethods = () => (dispatch, getState) => {
    dispatch({type: ActionTypes.GET_MFA_METHODS_REQUEST});
    auth.getMfaMethods().then(
        response => {
            dispatch({type: ActionTypes.GET_MFA_METHODS_SUCCESS, data: response})
        },
        error => {
            dispatch({
                type: ActionTypes.GET_MFA_METHODS_FAILURE,
                code: (error.response && error.response.error) || null,
                message: `Error: ${error.response.data.error_description || ''}`
            });
        }
    );
};

export const logout = (dispatch) => {
    auth.signOutUser();
    dispatch({type: ActionTypes.LOGOUT});
};

const oauthActions = {
    getUserInfo,
    getApplications,
    activateApplication,
    getMfaMethods,
    logout
};

export default oauthActions;
